import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=d9977db2"
import script from "../services/Settings.js?vue&type=script&lang=js&external"
export * from "../services/Settings.js?vue&type=script&lang=js&external"
import style0 from "./Settings.vue?vue&type=style&index=0&id=d9977db2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports